import React from "react";
import { Card, Col } from "react-bootstrap";

import { DashBoardPieCharts } from "./";
import { Common } from "../../../helper"

import "../../../assets/stlyes/Dashboard/DashboardDemographics.scss";

const DashboardDemographics = (props) => {
  const { demographicData } = props;

  return (
    <Card className="d-flex dashBoardDemographyMain" >
      <div className="abc">
        <div className="displayCountMain" style={{width: demographicData.totalPupil!==0 ?"":"-webkit-fill-available"}}>
          <div className="d-flex justify-content-center align-items-center flex-column pupilCountDiv"><span className="pupilTitle">Pupils</span><span className="pupilCount">{demographicData.totalPupil}</span></div>
          <div className="d-flex justify-content-center align-items-center flex-column teacherCountDiv" ><span className="teacherTitle">Teachers</span><span className="teacherCount">{demographicData.totalTeacher}</span></div>
        </div>
        {demographicData.totalPupil !== 0 ? <Col className="demographyMain">
          <div className="demographyTitle">{Common.Demographics}</div>
          <div className="d-flex justify-content-evenly pieChartPart">
            {demographicData.pieChart.map((item, i) => {
              return (<DashBoardPieCharts key={i} item={item} />)
            })}
          </div>
        </Col> : <></>}
      </div>
    </Card>
  )
}

export { DashboardDemographics }